import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { addProjectToLatestActiveProjects } from 'store/projects/projectsSlice';
import { postActivityLog } from '../services/postActivityLog.service';

/**
 * Logs that the current user opened a record (the edit-record dialog) — VIEW_RECORD.
 * Mirrors logProjectOpened: stamps the project (so the backend resolves business_id)
 * and the target (the record), and keeps the project fresh in the latest list.
 * Best-effort (createAsyncThunk routes failures to a `rejected` action).
 */
export const logRecordOpened = createAsyncThunk(
  'activityLog/logRecordOpened',
  async ({ projectId, recordId, recordName }, { dispatch, getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    dispatch(
      addProjectToLatestActiveProjects({ projectId, activeEmployerInfo })
    );

    return postActivityLog({
      projectId,
      action: 'VIEW_RECORD',
      targetType: 'RECORD',
      targetId: recordId,
      targetName: recordName,
      activeEmployerInfo,
    });
  }
);
